import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/logo-tarefando.png'


const _hoisted_1 = { class: "sideBar is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo Tarefando"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Lembre-se que seu cerébro também precisa descansar, por isso é importante aplicar pausas regulares durante suas tarefas! ", -1)
const _hoisted_4 = {
  key: 0,
  class: "fa-solid fa-sun"
}
const _hoisted_5 = {
  key: 1,
  class: "fa-sharp fa-solid fa-moon"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-rotate" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("button", {
      type: "button",
      class: "button btn-mode",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeTheme && _ctx.changeTheme(...args)))
    }, [
      (_ctx.setMode)
        ? (_openBlock(), _createElementBlock("i", _hoisted_4))
        : (_openBlock(), _createElementBlock("i", _hoisted_5)),
      _createTextVNode(_toDisplayString(_ctx.textButton), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      class: "button btn-reload",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reloadPage && _ctx.reloadPage(...args)))
    }, [
      _hoisted_6,
      _createTextVNode("Resetar ")
    ])
  ]))
}